import { cn } from "@/lib/utils";

type ChipVariant =
  | "orange"
  | "cyan"
  | "slate"
  | "blue"
  | "amber"
  | "emerald"
  | "violet"
  | "rose";

interface StatusChipProps {
  variant: ChipVariant;
  children: React.ReactNode;
  withDot?: boolean;
  className?: string;
}

const VARIANT_CLASS: Record<ChipVariant, string> = {
  orange: "chip-orange",
  cyan: "chip-cyan",
  slate: "chip-slate",
  blue: "chip-blue",
  amber: "chip-amber",
  emerald: "chip-emerald",
  violet: "chip-violet",
  rose: "chip-rose",
};

export function StatusChip({
  variant,
  children,
  withDot = true,
  className,
}: StatusChipProps) {
  return (
    <span className={cn("chip", VARIANT_CLASS[variant], className)}>
      {withDot && <span className="chip-dot" aria-hidden />}
      {children}
    </span>
  );
}
